import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "reactstrap";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { ColumnMenu } from "../components/kendoComponents/columnMenu/ColumnMenu";
import { GridPager } from "../components/kendoComponents/gridPager/GridPager";
import { ColumnProps } from "../components/kendoComponents/columnProps/ColumnProps";
import { DateCell } from "../components/kendoComponents/dateCell/DateCell";
import { AtlanCell } from "../components/customRender/renders/Renders";
import {
  fetchProductTypeList,
  setCallWithUser,
} from "../store/app/DataRollCall/DataRollCallSlice";
import { useNavigate } from "react-router-dom";
import LoaderSpin from "../components/loaderSpin/LoaderSpin";
import ModalManualValidation from "../components/manualValidation/ModalManualValidation";
import "../assets/scss/kendo-theme-custom.scss";
import FilterOverlay from "../components/filterOverlay/FilterOverlay";
import RollCallFilterForm from "../components/DataQuality/RollCallFilterForm";
import useRollCallGrid from "../components/hooks/useRollCallGrid";
import PropTypes from "prop-types";

const LastValidVersionCell = ({ dataItem, searchParams, navigate }) => {
  const handleNavigate = () => {
    navigate(`/versioni/detail/${dataItem.previousValidVersionId}?${searchParams.toString()}`);
  };

  return (
    <td>
      <button
        type="button"
        style={{ cursor: "pointer", background: "none", border: "none", padding: 0 }}
        className="fw-bold text-decoration-underline"
        onClick={handleNavigate}
        onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") handleNavigate(); }}
        tabIndex={0}
        aria-label={`Go to version ${dataItem.previousValidVersionId}`}
      >
        {dataItem.previousValidVersionId}
      </button>
    </td>
  );
};

LastValidVersionCell.propTypes = {
  dataItem: PropTypes.object.isRequired,
  navigate: PropTypes.func.isRequired,
  searchParams: PropTypes.object.isRequired,
};

const ProductTypeListRollCall = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);

  const refreshCount = useSelector((state) => state.dataQualityReducer.refreshCount);
  const callWithUser = useSelector((state) => state.dataRollCallReducer.callWithUser);
  const isSpinnerVisible = useSelector((state) => state.dataQualityReducer.loading);
  const dataCheck = useSelector((state) => state.dataQualityReducer.dataCheck);
  const productTypeList = useSelector((state) => state.dataRollCallReducer.productTypeList || []);
  const filterDomains = useSelector((state) => state.dataQualityReducer.filterDomains);
  const filterDataProducts = useSelector((state) => state.dataQualityReducer.filterDataProducts);
  const filterStatusCount = useSelector((state) => state.dataRollCallReducer.filterStatusCountDomains);

  const { dataState, dataResult, onDataStateChange } = useRollCallGrid(productTypeList);

  const [modal, setModal] = useState(false);
  const toggleManualValidation = () => setModal(!modal);

  useEffect(() => {
    dispatch(fetchProductTypeList(filterStatusCount, filterDomains, callWithUser, filterDataProducts));
    dispatch(setCallWithUser(false));
  }, [refreshCount, navigate]);

  const renderLastValidVersionCell = (props) => (
    <LastValidVersionCell {...props} navigate={navigate} searchParams={searchParams} />
  );

  return (
    <>
      <RollCallFilterForm />
      <Container fluid className="py-2 px-4 position-relative">
        <Row>
          <Col>
            <div className="grid_task_container border">
              <Grid
                style={{ height: "100%" }}
                pageable={true}
                sortable={true}
                groupable={true}
                total={dataResult?.length}
                data={dataResult}
                {...dataState}
                pager={(props) => GridPager(props, productTypeList)}
                onDataStateChange={onDataStateChange}
              >
                <Column {...ColumnProps("productName", dataState)} title="Product" columnMenu={ColumnMenu} cell={(props) => AtlanCell(props, "productName", "typeHandle")} />
                <Column {...ColumnProps("referenceDate", dataState)} title="Expected Reference Date" columnMenu={ColumnMenu} cell={(props) => DateCell(props, false)} />
                <Column {...ColumnProps("windowStartTs", dataState)} title="Window Start" columnMenu={ColumnMenu} cell={(props) => DateCell(props, true)} />
                <Column {...ColumnProps("windowEndTs", dataState)} title="Window End" columnMenu={ColumnMenu} cell={(props) => DateCell(props, true)} />
                <Column {...ColumnProps("rollCallStatusName", dataState)} title="SLA Status" />
                <Column {...ColumnProps("rollCallSeverityName", dataState)} title="Severity" />
                <Column {...ColumnProps("previousValidVersionId", dataState)} title="Last Valid Version" columnMenu={ColumnMenu} cell={renderLastValidVersionCell} />
                <Column {...ColumnProps("previousValidReferenceDate", dataState)} title="Reference Date last valid Version" columnMenu={ColumnMenu} cell={(props) => DateCell(props, false)} />
                <Column {...ColumnProps("previousValidCreationTs", dataState)} title="Creation Date last valid Version" columnMenu={ColumnMenu} cell={(props) => DateCell(props, true)} />
              </Grid>
            </div>
          </Col>
        </Row>
        <LoaderSpin isVisible={isSpinnerVisible} />
        <FilterOverlay isVisible={dataCheck} />
      </Container>
      <ModalManualValidation modal={modal} toggleManualValidation={toggleManualValidation} />
    </>
  );
};

export default ProductTypeListRollCall;